module.exports = __webpack_public_path__ + "static/img/tmptype1.bcf6b9d0.png";